export const loadOsano = () => {
  document.head.appendChild(
    Object.assign(document.createElement('script'), {
      type: 'text/javascript',
      src: 'https://cmp.osano.com/AzyXWrSv5dqLM1NvD/dceee96a-c6d9-42ef-a812-e15b60a8a5b3/osano.js',
    })
  )
}
